import defaultConfig from "./default";
import localConfig from "./local";
import devConfig from "./dev";
import testConfig from "./test";
import productionConfig from "./production";
import qaConfig from "./qa";
export { default as appConfig } from "./application";

export const envs = {
  LOCAL: "local",
  DEV: "development",
  QA: "qa",
  TEST: "test",
  PRODUCTION: "prod",
};

const selectedConfig = (() => {
  switch (process.env.REACT_APP_ENV) {
    case envs.LOCAL:
      return localConfig;
    case envs.DEV:
      return devConfig;
    case envs.TEST:
      return testConfig;
    case envs.QA:
      return qaConfig;
    case envs.PRODUCTION:
      return productionConfig;
    default:
      return defaultConfig;
  }
})();

export const {
  api,
  // @ts-ignore
  scConfig,
  auth,
  googleAnalyticsCode,
  googlemapsApiKey,
  awsWafUrl,
} = selectedConfig;

export default selectedConfig;
